import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M241.539-260.001L130.924-149.387q-8.846 8.846-19.884 4.423-11.039-4.423-11.039-16.885v-625.842q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v455.382q0 30.308-21 51.308t-51.308 21H241.539zM480-467.154l71.384 43.307q9.846 6.231 19.692-.692t7.231-18.769l-18.846-81.231 63.384-54.768q9.231-8.231 5.616-19.385-3.616-11.154-16.077-12.154l-83.23-7-32.693-76.615q-4.615-10.846-16.461-10.846-11.846 0-16.461 10.846l-32.693 76.615-83.23 7q-12.461 1-16.077 12.154-3.615 11.154 5.616 19.385l63.384 54.768-18.846 81.231q-2.615 11.846 7.231 18.769 9.846 6.923 19.692.692L480-467.154z"
      ></path>
    </svg>
  );
}

export default Icon;
